<mat-slider [showTickMarks]="true"
            [disableRipple]="true"
            min="0"
            max="12">
    <input class="slider--input input--min" value="0" matSliderStartThumb (valueChange)="_onStartMonthValueChange($event)">
    <input class="slider--input input--max" value="12" matSliderEndThumb (valueChange)="_onEndMonthValueChange($event)">
</mat-slider>
